jQuery(document).ready(function($) {
    $('.flash-sale-products-countdown-widget').each(function() {
        var $this = $(this);

        var endTimeAttr = $this.data('end-time');
        var endTime = endTimeAttr ? new Date(endTimeAttr).getTime() : null;

        function getSecondsRemaining() {
            if (endTime) {
                var now = new Date().getTime();
                var diff = Math.floor((endTime - now) / 1000);
                return diff > 0 ? diff : 0;
            } else {
                // fallback nếu không có end-time
                return parseInt($this.data('seconds-remaining')) || 0;
            }
        }

        var secondsRemaining = getSecondsRemaining();

        if (secondsRemaining > 0) {
            function updateCountdown() {
                if (secondsRemaining > 0) {
                    var days = Math.floor(secondsRemaining / (60 * 60 * 24));
                    var hours = Math.floor((secondsRemaining % (60 * 60 * 24)) / (60 * 60));
                    var minutes = Math.floor((secondsRemaining % (60 * 60)) / 60);
                    var seconds = secondsRemaining % 60;

                    days = days < 10 ? "0" + days : days;
                    hours = String(hours).padStart(2, "0");
                    minutes = String(minutes).padStart(2, "0");
                    seconds = String(seconds).padStart(2, "0");

                    if (days === "00") {
                        $this.find('.countdown-days').parent().hide();
                        $this.find('.countdown-days').closest('.countdown-item').next('.text-black').hide();
                    } else {
                        $this.find('.countdown-days').text(days);
                    }

                    $this.find('.countdown-hours').text(hours);
                    $this.find('.countdown-minutes').text(minutes);
                    $this.find('.countdown-seconds').text(seconds);

                    secondsRemaining--;
                } else {
                    clearInterval(interval);
                    // Optional: Hiển thị đã kết thúc
                    $this.html('<span class="text-red-500">Đã kết thúc</span>');
                }
            }

            updateCountdown(); // chạy lần đầu
            var interval = setInterval(updateCountdown, 1000);
        }
    });
});
